import { render } from "./SplitDowntimeDialog.vue?vue&type=template&id=4c4e19c6&scoped=true"
import script from "./SplitDowntimeDialog.vue?vue&type=script&lang=js"
export * from "./SplitDowntimeDialog.vue?vue&type=script&lang=js"

import "./SplitDowntimeDialog.vue?vue&type=style&index=0&id=4c4e19c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4e19c6"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBar,QSpace,QBtn,QTooltip,QBanner,QIcon,QForm,QSeparator});qInstall(script, 'directives', {ClosePopup});
